import React from 'react';
import { bemClasses } from '../../helpers';
export var ServerSecurityFlowScopes = function (_a) {
    var scopes = _a.scopes;
    return (React.createElement("ul", { className: bemClasses.element("server-security-scopes-list") }, Object.entries(scopes).map(function (_a) {
        var name = _a[0], description = _a[1];
        return (React.createElement("li", { className: bemClasses.element("server-security-scopes-list-item"), title: description, key: name },
            React.createElement("span", { className: bemClasses.element("server-security-scope") }, name)));
    })));
};
//# sourceMappingURL=Scopes.js.map